<style lang="scss" scoped>
header {
    &.scrollup {
        transform: translateY(-36px);

        .usp-bar {
            .row {
                > div {
                    opacity: 0;
                }
            }
        }
    }

    .logo {
        width: auto;
        height: 40px;

        @media screen and (max-width: 768px) {
            width: auto;
            height: 25px;
        }
    }
}
</style>

<template>
    <header class="fixed z-50 w-screen transition duration-300 delay-200" :class="{ scrollup: sticky, 'delay-300': sticky }">
        <div class="bg-blue usp-bar py-8 text-white">
            <div class="container">
                <div class="row">
                    <p v-if="$store.getters['indupackStore/isReseller']" style="line-height: 1.25rem" class="transform -translate-y-1 w-full text-center" v-html="headerData.reseller_tekst.replace(/\{{(.+?)\}}/g, $store.getters['indupackStore/percentage'])"></p>
                    <template v-else>
                        <div v-for="(usp, index) in headerData.header_usps" :key="index" class="lg:w-1/3 first:flex text-white lg:flex items-center justify-center hidden w-full transition-opacity delay-200">
                            <span v-html="svg(usp.svg_name, 'fill-[currentColor] mr-8')"></span>
                            <p style="line-height: 1.25rem" class="transform whitespace-nowrap -translate-y-1" v-html="usp.description"></p>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="md:pt-32 md:pb-24 py-16 bg-white border-b border-gray-300">
            <div class="container">
                <div class="flex items-center justify-center">
                    <a class="flex-shrink-0" :href="$root.homeUrl"><img class="logo" src="/svg/indupack.svg" alt="Indupack"/></a>
                    <menu-toggle class="flex xl:hidden items-center ml-auto md:ml-40">
                        <span v-html="svg('hamburger-static', 'fill-[currentColor] text-blue mr-16 mt-2 ')"></span>
                        <span class="text-dark md:inline hidden font-bold" v-html="headerData.menu_label"></span>
                    </menu-toggle>
                    <div v-if="menu" class="xl:flex hidden items-center flex-1 mr-auto ml-32">
                        <template v-for="(item, index) in menu">
                            <div :key="index" v-if="item.show_in_menu" class="relative whitespace-nowrap mr-24 last:mr-0 group">
                                <div class="inline-flex items-center" :set="(collection = getCollectionById(item.collection))">
                                    <a v-if="item.type === 'page'" :href="`/${document.documentElement.lang}${item.page.post_name && item.page.post_name !== 'home' ? '/' + item.page.post_name : ''}`" class="text-dark font-bold" v-html="item.name"></a>
                                    <a v-else-if="collection" :href="`/${document.documentElement.lang}/${productSlug}/${collection.slug}`" class="text-dark font-bold" v-html="item.name"></a>
                                    <span v-if="item.children && item.children.length > 0" v-html="svg('chevron-down', 'h-16 w-auto translate-y-1')"></span>
                                </div>
                                <transition name="fade">
                                    <div class="absolute z-50 top-full pt-2 right-0 hidden group-hover:block" v-if="item.children && item.children.length > 0">
                                        <div class="bg-white min-w-[200px] flex flex-col rounded-xs border border-gray-100">
                                            <template v-for="(child, index) in item.children">
                                                <a v-if="child.type === 'page'" :key="index" class="py-10 px-[15px] bg-white hover:bg-gray-100 font-semibold" :class="{ 'text-primary': currentPath === `/${document.documentElement.lang}/${item.page.post_name}` }" :href="`/${document.documentElement.lang}/${item.page.post_name}`">{{ child.name }}</a>
                                                <div v-else :key="index" :set="(collection = getCollectionById(child.collection))" class="py-10 px-[15px] bg-white hover:bg-gray-100 font-semibold">
                                                    <a v-if="collection" :key="index" :class="{ 'text-primary': currentPath === `/${document.documentElement.lang}/${productSlug}/${collection.slug}` }" :href="`/${document.documentElement.lang}/${productSlug}/${collection.slug}`">{{ child.name === '' ? collection.name : child.name }}</a>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </template>
                    </div>
                    <div class="flex items-center justify-end md:flex-1 xl:ml-auto">
                        <div class="relative h-full inline-flex items-center justify-center lg:mr-16">
                            <div @click="showLanguagePicker = !showLanguagePicker" class="language-picker-toggle px-16 inline-flex items-center cursor-pointer select-none font-bold text-dark uppercase">
                                <span v-html="svg(currentLanguage, 'h-20 w-auto mr-8')"></span>
                                {{ currentLanguage }}
                                <span v-html="svg('chevron-down', 'h-16 w-auto translate-y-1')"></span>
                            </div>
                            <transition name="fade">
                                <div class="absolute z-50 top-full pt-2 right-0" v-click-outside="languagePickerClickOutside" v-if="showLanguagePicker">
                                    <div class="bg-white min-w-[200px] flex flex-col rounded-xs border border-gray-100">
                                        <template v-for="(language, key) in languages">
                                            <a class="py-10 px-[15px] bg-white inline-flex items-center gap-8 hover:bg-gray-100 font-semibold" :class="{ 'text-primary': currentLanguage === key }" :href="translatedRoutes[key] ? translatedRoutes[key].relative_url : `/${key}`"><span v-html="svg(key, 'h-20 w-auto mr-8')"></span> {{ language }}</a>
                                        </template>
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <a :href="$root.contactUrl" class="text-blue inline-block mr-16 lg:mr-32">
                            <span v-html="svg('mail', 'fill-[currentColor] ')"></span>
                        </a>
                        <div class="hidden md:block mr-16 lg:mr-32">
                            <search-bar :placeholder="headerData.search_placeholder">
                                <div class="text-blue inline-block">
                                    <span v-html="svg('search', 'fill-[currentColor] ')"></span>
                                </div>
                            </search-bar>
                        </div>
                        <shopping-basket-counter :href="$root.basketUrl" class="text-blue">
                            <span v-html="svg('shopping-cart', 'fill-[currentColor] ')"></span>
                        </shopping-basket-counter>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
    name: 'Ui.StickyHeader',

    directives: { ClickOutside },

    props: {
        headerData: {
            type: Object,
            required: true,
        },
        currentLanguage: {
            type: String,
            required: true,
        },
        languages: {
            type: Object | Array,
            required: true,
        },
        collections: {
            type: Array,
            default: () => [],
        },
        translatedRoutes: {
            type: Object | Array,
            default: () => [],
        },
    },

    data() {
        return {
            sticky: false,
            showLanguagePicker: false,
            document: document,
        };
    },

    async mounted() {
        const self = this;

        let last_known_scroll_position = 0;
        let ticking = false;
        let body = document.body,
            html = document.documentElement;

        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

        window.addEventListener('scroll', function(e) {
            last_known_scroll_position = window.scrollY;

            let height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

            if (!ticking) {
                window.requestAnimationFrame(function() {
                    if (last_known_scroll_position > (vh / 100) * 60 && height > vh) {
                        self.sticky = true;
                    } else {
                        self.sticky = false;
                    }

                    ticking = false;
                });

                ticking = true;
            }
        });
    },

    computed: {
        currentPath() {
            return window.location.pathname;
        },

        productSlug() {
            switch (document.documentElement.lang) {
                case 'nl':
                    return 'producten';
                case 'fr':
                    return 'produits';
                case 'de':
                    return 'produkte';
                case 'en':
                    return 'products';
            }
        },

        menu() {
            return this.$store.getters['general/menu'];
        },
    },

    methods: {
        languagePickerClickOutside(event) {
            if (event.target.closest('.language-picker-toggle') == null) {
                this.showLanguagePicker = false;
            }
        },
        getCollectionById(id) {
            return this.collections.find(collection => collection.id === parseInt(id));
        },
    },
};
</script>
